import PropTypes from 'prop-types';
// @mui
import { Box, TableRow, TableCell, TableHead } from '@mui/material';

// ----------------------------------------------------------------------

const visuallyHidden = {
    border: 0,
    margin: -1,
    padding: 0,
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    clip: 'rect(0 0 0 0)',
};

DepartmentListHead.propTypes = {
    order: PropTypes.oneOf(['asc', 'desc']),
    orderBy: PropTypes.string,
    rowCount: PropTypes.number,
    headLabel: PropTypes.array,
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func,
    onSelectAllClick: PropTypes.func,
};

export default function DepartmentListHead({ headLabel }) {
    return (
        <TableHead
            sx={{
                position: 'sticky',
                top: 0,
                backgroundColor: 'white',
                zIndex: 4,
            }}
        >
            <TableRow>
                <TableCell padding="checkbox"></TableCell>
                {headLabel.map((headCell, index) => (
                    <TableCell
                        key={index}
                        sx={{
                            whiteSpace: 'nowrap',
                            ...(headCell.stickyEnd && {
                                position: 'sticky',
                                right: 0,
                                backgroundColor: 'white',
                                zIndex: 3,
                                backgroundColor: '#f4f6f8',
                            }),
                        }}
                    >
                        {headCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
